import { render, staticRenderFns } from "./LessonReader.vue?vue&type=template&id=65eb1924&scoped=true"
import script from "./LessonReader.vue?vue&type=script&lang=js"
export * from "./LessonReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb1924",
  null
  
)

export default component.exports